import axios from 'axios';
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';
import i18n from 'i18next';

// Import store
import store from 'store/store';

// Import helpers
import { checkErrorStatus } from 'services/helpers';
import { getDeviceUID } from 'helpers/headers';
import { getUserToken } from 'helpers/auth';
import { getAppCheckToken } from 'helpers/firebase';

const uuid = getDeviceUID();

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'API-DeviceUID': uuid,
		'API-Device': `${browserName}; ${browserVersion}; ${osName}; ${osVersion}; ${osName}; ${process.env.REACT_APP_VERSION};`
	},
	params: {
		platform: 'BROWSER'
	}
});

instance.interceptors.request.use(
	async function (config) {
		const { subscriber } = store.getState();
		const token = getUserToken();

		// query params
		config.params = config.params || {};
		config.params.language = i18n.language;
		config.params.rating = subscriber.details?.parental_control_rating || null;
		config.params.system = config.data?.system ?? config.params.system ?? subscriber.details?.system ?? process.env.REACT_APP_SYSTEM;

		// headers
		config.headers['X-Firebase-AppCheck'] = await getAppCheckToken();

		if (!config.headers.Authorization && token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use((response) => response, checkErrorStatus);

export default instance;
